<div
    class="card-bg rounded-2xl overflow-hidden border border-white/10 backdrop-blur-3xl shadow-2xl w-[800px] max-w-full animate-in zoom-in-95 duration-300">
    <!-- Header -->
    <div class="px-8 py-5 border-b border-white/5 flex items-center justify-between bg-white/5">
        <h2 class="text-xl font-bold bg-gradient-to-r from-violet-400 to-indigo-500 bg-clip-text text-transparent">
            {{ isEditMode() ? 'Edit Configuration' : 'Create New Release Prompt' }}
        </h2>
        <button (click)="dialogRef.close()"
            class="text-slate-400 hover:text-white transition-colors duration-200 p-2 hover:bg-white/10 rounded-full">
            <app-icon name="x" [size]="20" />
        </button>
    </div>

    <!-- Body -->
    <div class="p-8 space-y-8">
        <!-- Dropdowns Grid -->
        <div class="grid grid-cols-12 gap-6">
            <div class="col-span-12 md:col-span-4">
                <label class="block mb-2 text-xs font-semibold uppercase tracking-wider text-slate-400">Available
                    Products</label>
                @if (products().length > 0) {
                <app-dropdown [options]="productOptions()" [selectedValue]="String(productId())" selectionMode="single"
                    placeholder="Select product" [fullWidth]="true" (selectionChange)="onProductChange($event)" />
                } @else {
                <div
                    class="h-10 w-full animate-pulse bg-slate-100 dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-white/5">
                </div>
                }
            </div>

            <div class="col-span-12 md:col-span-4">
                <label class="block mb-2 text-xs font-semibold uppercase tracking-wider text-slate-400">Features</label>
                @if (features().length > 0) {
                <app-dropdown [options]="featureOptions()" [selectedValue]="String(featureId())" selectionMode="single"
                    placeholder="Select feature" [fullWidth]="true" (selectionChange)="onFeatureChange($event)" />
                } @else {
                <div
                    class="h-10 w-full animate-pulse bg-slate-100 dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-white/5">
                </div>
                }
            </div>

            <div class="col-span-12 md:col-span-4">
                <label class="block mb-2 text-xs font-semibold uppercase tracking-wider text-slate-400">Feature
                    Options</label>
                @if (options().length > 0) {
                <app-dropdown [options]="optionOptions()" [selectedValue]="String(optionId())" selectionMode="single"
                    placeholder="Select option" [fullWidth]="true" (selectionChange)="onOptionChange($event)"
                    [disabled]="!featureId()" />
                } @else {
                <div
                    class="h-10 w-full animate-pulse bg-slate-100 dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-white/5">
                </div>
                }
            </div>

            @if (hasCategories()) {
            <div class="col-span-12 md:col-span-4">
                <label class="block mb-2 text-xs font-semibold uppercase tracking-wider text-slate-400">
                    Category
                    <span class="text-rose-400 normal-case ml-1">*</span>
                </label>
                <app-dropdown [options]="categoryOptions()" [selectedValue]="String(categoryId())"
                    selectionMode="single" placeholder="Select category" [fullWidth]="true"
                    (selectionChange)="onCategoryChange($event)" [disabled]="!optionId()" />
            </div>
            }
        </div>

        <!-- Textarea -->
        <div class="space-y-2">
            <label class="block mb-2 text-xs font-semibold uppercase tracking-wider text-slate-400">System
                Implementation Prompt</label>
            <app-textarea label="" [ngModel]="promptText()" (ngModelChange)="promptText.set($event)"
                placeholder="Define the behavior, personality, and instructions for the AI bot here..." [rows]="12" />
        </div>
    </div>

    <!-- Footer -->
    <div class="px-8 py-5 border-t border-white/5 flex items-center justify-end gap-4 bg-black/10">
        <app-button variant="secondary" (buttonClick)="dialogRef.close()">Discard Draft</app-button>
        <app-button variant="primary" (buttonClick)="submit()" [disabled]="!canDeploy()"
            className="!py-3 !px-8 text-sm font-semibold flex items-center gap-2">
            <app-icon [name]="isEditMode() ? 'circleCheckBig' : 'circlePlus'" [size]="18" />
            {{ isEditMode() ? 'Deploy Release' : 'Deploy Release' }}
        </app-button>
    </div>
</div>